import { useState } from 'react';
import { Icon } from './Icon.js';
import { ObjectPicker } from './ObjectPicker.js';
import type { PickableObject } from '../state/pickableObjects.js';
import type { EditableKind } from '../state/opDraft.js';

/** Exported — Task 4 reuses this exact label set for the kind-chip row. */
export const KIND_LABEL: Record<EditableKind, string> = {
  entity: 'Entity',
  surface: 'Surface',
  'cloud-function': 'Cloud Function',
  'event-type': 'Event Type',
  'firestore-path': 'Firestore Path',
};

export interface ObjectContextHeaderProps {
  kind: EditableKind;
  id: string;
  subtitle: string;
  pickableItems: readonly PickableObject[];
  onChangeObject: (kind: EditableKind, id: string) => void;
}

export function ObjectContextHeader({
  kind,
  id,
  subtitle,
  pickableItems,
  onChangeObject,
}: ObjectContextHeaderProps): React.JSX.Element {
  const [pickerOpen, setPickerOpen] = useState(false);

  return (
    <div className="object-context-header">
      <div className="object-context-row">
        <Icon name="edit_note" size="sm" />
        <span className="object-context-text">
          <strong>Editing {KIND_LABEL[kind]}</strong> · <span className="mono">{id}</span> · {subtitle}
        </span>
        <button type="button" className="btn btn-ghost btn-xs" onClick={() => setPickerOpen((v) => !v)}>
          Change object
        </button>
      </div>
      {pickerOpen && (
        <ObjectPicker
          items={pickableItems}
          value={id}
          ariaLabel="Change which object you're editing"
          onChange={(newId) => {
            const picked = pickableItems.find((p) => p.id === newId);
            if (picked) onChangeObject(picked.kind, picked.id);
            setPickerOpen(false);
          }}
        />
      )}
    </div>
  );
}
